import { render, staticRenderFns } from "./noResults.vue?vue&type=template&id=72c62fa2&scoped=true"
import script from "./noResults.vue?vue&type=script&lang=js"
export * from "./noResults.vue?vue&type=script&lang=js"
import style0 from "./noResults.vue?vue&type=style&index=0&id=72c62fa2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c62fa2",
  null
  
)

export default component.exports